<template>
  <v-card flat>
    <v-card-text v-if=" tab.description" class="grey lighten-4">
      <p>{{tab.description}}</p>
    </v-card-text>
    <v-divider v-if="tab.description"></v-divider>

    <section>
      <v-container class="pa-0">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-list two-line subheader class="scroll-box py-0">
              <template v-for="(item,i) in tab.files">
                <v-list-item :key="`document-${i}`" :href="item.url" target="_blank">
                  <v-list-item-avatar>
                    <v-icon>{{fileIcon(item.name)}}</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle>{{(item.size/1000).toFixed(1)}}kb</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action @click="removeItem(item,$event)">
                    <v-btn icon>
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`document-divider-${i}`"></v-divider>
              </template>

              <template v-for="(item,i) in uploads">
                <v-list-item :key="`document-upload-${i}`" :href="item.url">
                  <v-list-item-avatar>
                    <v-icon>{{fileIcon(item.file.name)}}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.file.name"></v-list-item-title>
                    <v-list-item-subtitle>{{(item.file.size/1000).toFixed(1)}}kb</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-progress-circular
                      :size="30"
                      color="primary"
                      :indeterminate="item.status==='Uploading' ? false: true"
                      :value="item.progress"
                    ></v-progress-circular>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`document-upload-divider-${i}`"></v-divider>
              </template>

              <v-list-item v-if="canUpload">
                <v-list-item-avatar></v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <div
                    :class="`${tab.files.length + uploads.length > 0 ? 'py-6' : 'py-12'} text-center`"
                  >
                    <v-btn
                      fab
                      :color="section.button_color"
                      :dark="isButtonDark"
                      @click="$refs['filepicker'].click()"
                    >
                      <v-icon>fa-plus</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
                <v-list-item-action></v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <input
      type="file"
      style="display:none"
      ref="filepicker"
      :multiple="tab.multiple"
      @change="handleFiles($event)"
      accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf"
    />
  </v-card>
</template>

<script>
var isFacebookApp = function () {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (
    ua.indexOf("FBAN") > -1 ||
    ua.indexOf("FBAV") > -1 ||
    ua.indexOf("Instagram") > -1
  );
};

export default {
  name: "PortalSectionDocumentTab",
  props: ["value", "section", "portal", "access_code"],
  data() {
    return {
      uploads: [],
      slide: "",
    };
  },
  created() {
    if (isFacebookApp()) {
      this.$refs["filepicker"].removeAttr("accept");
    }
  },
  components: {},
  computed: {
    canUpload() {
      if (this.uploads.length && !this.tab.multiple) {
        return false;
      }

      if (this.tab.files.length || this.uploads.length) {
        if (!this.tab.multiple) {
          return false;
        }
        if (
          this.tab.files.length + this.uploads.length >=
          this.$store.state.website.portal_limits.documents
        ) {
          return false;
        }
      }
      return true;
    },
    tab() {
      return this.value;
    },
    isButtonDark() {
      return this.$helpers.lightOrDark(this.section.button_color) === "dark";
    },
    slideWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp === "xs") {
        return 190;
      }
      if (bp === "sm") {
        return 240;
      }
      if (bp === "md") {
        return 173;
      }
      if (bp === "lg") {
        return 205;
      }
      return 240;
    },
  },
  methods: {
    uploadFinished(upload) {
      this.uploads = this.uploads.filter((v) => {
        return v !== upload;
      });
      this.$store.commit("applicant_upload_ended", upload);
    },
    fileIcon(name) {
      if (name.endsWith(".pdf")) {
        return "fa-file-pdf";
      }
      if (name.endsWith(".doc")) {
        return "fa-file-word";
      }
      if (name.endsWith(".docx")) {
        return "fa-file-word";
      }
      if (name.endsWith(".ppt")) {
        return "fa-file-powerpoint";
      }
      if (name.endsWith(".csv") || name.endsWith(".xls")) {
        return "fa-file-excel";
      }

      return "fa-file-alt";
    },
    removeItem(v, ev) {
      ev.preventDefault();
      if (!confirm("Sure you want to remove that item ?")) {
        return;
      }
      this.tab.files = this.tab.files.filter((item) => {
        return item !== v;
      });
      this.$api.delete(
        `/applicant/portal/${this.portal.applicant_uid}?access_code=${
          this.access_code ? this.access_code : ""
        }`,
        {
          headers: {
            session_uid: this.portal.session_uid,
          },
          data: v,
        }
      );
    },
    async handleFiles(ev) {
      console.log("handleFiles", ev);
      let files = [];
      let max_size = this.$store.state.website.portal_limits.document_size;
      ev.target.files.forEach((f) => {
        if (
          ["pdf", "xls", "doc", "docx", "txt", "csv", "ppt"].includes(
            f.name.split(".")[f.name.split(".").length - 1]
          )
        ) {
          if (f.size <= max_size) {
            files.push(f);
          } else {
            alert(
              `${f.name} exceeds the maximum document size of ${
                max_size / 1000 / 1000
              }mb`
            );
          }
        } else {
          alert(
            `${f.name} is an unsupported file format. We support pdf, xls, doc, docx, txt, csv and ppt for document uploads.`
          );
        }
      });
      console.log("doc files", files);
      if (
        this.tab.files.length + files.length >
        this.$store.state.website.portal_limits.documents
      ) {
        alert(
          `You can upload a maximum of ${this.$store.state.website.portal_limits.documents} documents`
        );
      } else {
        await this.uploadFiles(files);
      }
      ev.target.value = null;
    },
    async uploadFiles(files) {
      console.log("uploadFiles", files);
      for (let index = 0; index < files.length; index++) {
        let upload = {
          progress: 0,
          status: "pending",
          file: files[index],
        };
        this.uploads.push(upload);
        this.$store.commit("applicant_upload_started", upload);
        this.uploadFile(upload);
      }
    },
    async uploadFile(upload) {
      let form = new FormData();
      form.append("file", upload.file);
      form.append("section", this.section.title);
      var upload_options = {
        headers: {
          "Content-Type": upload.file.type,
          session_uid: this.portal.session_uid,
        },
        Metadata: {
          "Content-Disposition": "attachment",
        },
        onUploadProgress: function (progressEvent) {
          upload.progress = parseInt(
            Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
          if (upload.progress >= 100) {
            upload.status = "Processing";
          } else {
            upload.status = "Uploading";
          }
        }.bind(this),
      };
      try {
        let uploaded = await this.$api.put(
          `/applicant/portal/${
            this.portal.applicant_uid
          }/upload-documents?access_code=${
            this.access_code ? this.access_code : ""
          }`,
          form,
          upload_options
        );

        this.tab.files.push(uploaded);
      } catch (ex) {
        alert(ex.error);
      }

      this.uploadFinished(upload);
    },
  },
};
</script>

<style scoped lang="scss">
.sheetbox {
  align-items: center;
  justify-content: center;
  display: flex;
}
.item-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 201;
}
</style>